// extracted by mini-css-extract-plugin
export default {"container":"line-chart_container__wyVZT","axis":"line-chart_axis__vWxIj"};